import { useLocation } from "react-router";
import { AllInvoiceFilters } from "../pages/invoices/AllInvoices/AllInvoices";

export const getHashParametersFromURL = (): string => useLocation().hash;

interface InvoiceQueryParams {
  documentNumber?: string;
  startDate?: string;
  endDate?: string;
}

function getMapOfHashParametersFromURL(): InvoiceQueryParams {
  const stringAfterHash = getHashParametersFromURL()
    .substring(getHashParametersFromURL().lastIndexOf("#") + 1)
    .split("&");

  const mapOfHashParameters = {};
  stringAfterHash.forEach((pair) => {
    const [key, value] = pair.split("=");
    // @ts-ignore
    mapOfHashParameters[key] = value;
  });
  return mapOfHashParameters;
}

const createDateFromString = (dateString: string) => {
  const year = Number(dateString.split("-")[0]);
  const month = Number(dateString.split("-")[1]) - 1;
  const day = Number(dateString.split("-")[2]);
  return new Date(year, month, day);
};

export const getInvoiceFilterQueryParameters = () => {
  const hashParameters = getMapOfHashParametersFromURL();

  const CURRENT_DATE = new Date();

  return {
    documentNumber: hashParameters.documentNumber ?? "",
    startDate: hashParameters.startDate
      ? createDateFromString(hashParameters.startDate)
      : // @ts-ignore
        new Date(CURRENT_DATE.fp_incr(-30)),
    endDate: hashParameters.endDate
      ? createDateFromString(hashParameters.endDate)
      : CURRENT_DATE,
  };
};

export const areInvoiceFilterQueryParametersSameAsFilter = (
  currentFilterState: AllInvoiceFilters
) => {
  const queryParamFilters = ["documentNumber", "startDate", "endDate"];
  const hashParameters = getMapOfHashParametersFromURL();

  if (Object.keys(hashParameters).length === 0) {
    return false;
  }

  return !Object.keys(currentFilterState).some((key) => {
    // @ts-ignore
    if (!queryParamFilters.includes(key) && currentFilterState[key] !== "") {
      return true;
    }
    if (queryParamFilters.includes(key)) {
      const currentFilterValue =
        // @ts-ignore
        typeof currentFilterState[key] === "string"
          ? // @ts-ignore
            currentFilterState[key]
          : // @ts-ignore
            currentFilterState[key]?.toISOString().split("T")[0];
      // @ts-ignore
      if (currentFilterValue !== hashParameters[key]) {
        return true;
      }
    }
    return false;
  });
};
